// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f1c29245","442":"e8022577","453":"da82b55e","633":"a4793668","732":"d4abdd4d","977":"ed43f4e7"}[chunkId] + ".chunk.js";
};